/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import './style.scss';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRankingStar } from '@fortawesome/free-solid-svg-icons';
import badge1 from '@Images/badge1.png';
import badge2 from '@Images/badge2.png';
import badge3 from '@Images/badge3.png';
import HideValue from '../../../../Common/RestrictedAccess/HideValue';

const Leaderboard = ({ value, MONEY, user, priceMasking }) => {
  const leaderboardData = [
    {
      position: 1,
      name: value[0]?.participant_name,
      value: value[0]?.negotiation_grand_total,
      badge: badge1,
      color: 'gold',
    },
    {
      position: 2,
      name: value[1]?.participant_name,
      value: value[1]?.negotiation_grand_total,
      badge: badge2,
      color: 'silver',
    },
    {
      position: 3,
      name: value[2]?.participant_name,
      value: value[2]?.negotiation_grand_total,
      badge: badge3,
      color: 'bronze',
    },
  ].filter((entry) => entry.value !== undefined);

  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  return (
    <div className="leaderboard">
      <div className="leadheader">
        <FontAwesomeIcon icon={faRankingStar} style={{ color: '#2D7DF7' }} />
        <h2>Top Vendors</h2>
      </div>
      <div className="leaderboard-list">
        {leaderboardData.map((entry) => (
          <div key={entry.position} className={`leaderboard-entry ${entry.color}`}>
            <div className="badge" style={{ width: '35px' }}>
              <img className="badge" src={entry.badge} />
            </div>
            <span className="name">{entry.name}</span>
            <span className="value">{(isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver /> : MONEY(entry.value)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = () => ({

});

Leaderboard.propTypes = {
  value: PropTypes.any,
  MONEY: PropTypes.any,
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Leaderboard));
